// 漫星负一屏小部件
export default {
  // 美国
  "en-mxwg.comfortweather.com": {
    ad1: [
      {
        type: "ads",
        slot: 6026967275,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "position-08",
      },
      {
        type: "ads",
        slot: 5855576887,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "ads",
        slot: 3011853329,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-09",
      },
      {
        type: "ads",
        slot: 3858031133,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-13",
      },
      {
        type: "ads",
        slot: 8072608310,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-14",
      },
      {
        type: "ads",
        slot: 8918786120,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 墨西哥
  "es-mxwg.comfortweather.com": {
    ad1: [
      {
        type: "ads",
        slot: 4979541117,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-08",
      },
      {
        type: "ads",
        slot: 7414132762,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "ads",
        slot: 7055040118,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-09",
      },
      {
        type: "ads",
        slot: 4596397733,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-13",
      },
      {
        type: "ads",
        slot: 1507199961,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-14",
      },
      {
        type: "ads",
        slot: 3115795104,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-15",
      },
    ],
  },
};
